import api from '../../api';

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, value);
  });
  return search.toString();
}

const state = {
  summary: null,
  eventsPayload: null,
  loadingSummary: false,
  loadingEvents: false,
  error: null,
};

const getters = {
  summary: (state) => state.summary,
  eventsPayload: (state) => state.eventsPayload,
  recentEvents: (state) => state.summary?.recentEvents || [],
  summaryDrones: (state) => state.summary?.perDroneSummary || [],
};

const mutations = {
  setSummary(state, payload) {
    state.summary = payload;
  },
  setEventsPayload(state, payload) {
    state.eventsPayload = payload;
  },
  setLoadingSummary(state, value) {
    state.loadingSummary = value;
  },
  setLoadingEvents(state, value) {
    state.loadingEvents = value;
  },
  setError(state, value) {
    state.error = value;
  },
};

const actions = {
  async fetchSummary({ commit }, params = {}) {
    commit('setLoadingSummary', true);
    try {
      const query = buildQuery(params);
      const { data } = await api.get(`/api/reports/summary${query ? `?${query}` : ''}`);
      commit('setSummary', data);
      commit('setError', null);
      return data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Не удалось загрузить dashboard summary');
      throw error;
    } finally {
      commit('setLoadingSummary', false);
    }
  },
  async fetchEvents({ commit }, params = {}) {
    commit('setLoadingEvents', true);
    try {
      const query = buildQuery(params);
      const { data } = await api.get(`/api/reports/events${query ? `?${query}` : ''}`);
      commit('setEventsPayload', data);
      commit('setError', null);
      return data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Не удалось загрузить отчеты');
      throw error;
    } finally {
      commit('setLoadingEvents', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
